// react, react-redux, redux-form
import React from 'react';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux'

const SaveAndExit = props => {
  const {savedApp, formName} = props;
  return (
    <div>
      <h1>Thank you</h1>
      <p>Your {formName.replace('Form', '')} application has been saved.</p>
      <p>If this was your first time saving your application a confirmation email will be sent to {savedApp.email} shortly, along with a password so you can use to retrieve your form.</p>
      <p>If this is not your first save, please refer to the first email sent to retrieve your draft.</p>
    
      <h2>Further Information</h2>
      <p>If you've got any further questions, please email us at <a href="mailto: heritage.permits@delwp.vic.gov.au">heritage.permits@delwp.vic.gov.au</a> or get in touch by phone on <a href="tel:03-7022-6370">03 7022 6370</a>.</p>
      <p>For all general DELWP enquiries, call <a href="tel:136-186">136 186</a>.</p>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    savedApp: state.app.savedApp
  }
}

export default connect(
  mapStateToProps
)(reduxForm({
  form: 'exemptionForm', //          <------ same form name
  destroyOnUnmount: false, //        <------ preserve form data
  forceUnregisterOnUnmount: true // <------ unregister fields on unmount
})(SaveAndExit))
